//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex';
import { MINIMISE_NAVIGATION } from '@/store/types/mutations';
import { SETTINGS, UI } from '@/store/types/namespaces';
import SectionNavigation from './Navigation/SectionNavigation.vue';
import User from './Navigation/User.vue';

const STATE_KEY = 'dp.nav';

export default {
  name: 'NavigationBar',
  components: {
    SectionNavigation,
    User,
  },
  data() {
    return {
      state: {
        isMinimised: false,
      },
      customScroll: null,
    };
  },
  computed: {
    ...mapState(SETTINGS, ['emblem']),
    toggleArrow() {
      return this.state.isMinimised ? 'bold-arrow-right' : 'bold-arrow-left';
    },
  },
  mounted() {
    this.restoreState();
  },
  methods: {
    ...mapMutations(UI, [MINIMISE_NAVIGATION]),
    toggleNavigation() {
      this.state.isMinimised = !this.state.isMinimised;
      this[MINIMISE_NAVIGATION](this.state.isMinimised);
      this.saveState(this.state);
    },
    saveState(state) {
      this.state = state;
      window.localStorage.setItem(STATE_KEY, JSON.stringify(this.state));
    },
    restoreState() {
      const state = window.localStorage.getItem(STATE_KEY);
      if (state) {
        this.state = JSON.parse(state);

        if (this.state.isMinimised) {
          this[MINIMISE_NAVIGATION](true);
        }
      }
    },
  },
};
